import { generateRoundTitle } from '@okletsplay/core';
import { KnockoutTournamentEntity, TournamentMatchGameEntity } from 'app/interfaces/entity';
import { useCallback } from 'react';

export type MatchGameProperties = Pick<
  TournamentMatchGameEntity,
  'roundNumber' | 'matchNumber' | 'groupNumber' | 'matchGameNumber'
>;

interface TournamentMatchTitleOptions {
  round?: boolean;
  match?: boolean;
  game?: boolean;
}

export const useTournamentMatchTitle = () => {
  const getTournamentMatchGameTitle = useCallback(
    (
      matchGame: MatchGameProperties | null,
      tournament: KnockoutTournamentEntity,
      options?: TournamentMatchTitleOptions
    ) => {
      if (!matchGame) {
        return '';
      }

      const defaultOptions = { round: true, match: true, game: true };
      const displaySettings = { ...defaultOptions, ...options };

      const roundIndex = matchGame ? (matchGame.roundNumber ?? 0) + 1 : 0;
      const matchNumber = matchGame ? (matchGame.matchNumber ?? 0) + 1 : 0;
      const matchGameNumber = matchGame.matchGameNumber ?? 0;

      const tournamentName = tournament?.name ?? 'Tournament';
      const rounds = tournament?.bracket?.rounds;

      const roundNumber = (rounds ?? []).find((round) =>
        round.matches.find((match) => match.externalId === matchGame.matchNumber)
      )?.number;

      if (!roundIndex || !matchNumber || !matchGameNumber || !rounds || roundNumber === undefined) {
        return `Match game ${tournamentName} is started!`;
      }

      const titleParts = [];
      if (displaySettings.round) {
        titleParts.push(
          generateRoundTitle(
            rounds,
            matchGame.groupNumber,
            roundNumber,
            tournament?.matchSetupSettings?.eliminationFormat
          )
        );
      }

      if (displaySettings.match) {
        titleParts.push(`Match ${matchNumber}`);
      }

      if (displaySettings.game) {
        titleParts.push(`Game ${matchGameNumber}`);
      }

      return titleParts.join(' / ');
    },
    []
  );

  return { getTournamentMatchGameTitle };
};
